import { useEffect, useState } from "react";
import { TrendingUp, AlertTriangle } from "lucide-react";
import { api, formatARS } from "@/lib/api";

const RANGES = [{ days: 7, label: "7 días" }, { days: 30, label: "30 días" }, { days: 90, label: "90 días" }];

export default function TopProducts() {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/stats/top-products", { params: { days, limit: 10 } }).then((r) => setData(r.data)).catch(() => setData({ rows: [] }));
  }, [days]);

  const max = data?.rows?.[0]?.quantity || 1;

  return (
    <section className="bg-white rounded-2xl border border-slate-200 overflow-hidden mb-6" data-testid="top-products">
      <div className="px-5 py-4 border-b border-slate-200 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-heading font-bold text-lg flex items-center gap-2"><TrendingUp className="w-5 h-5 text-green-600" /> Productos más pedidos</h2>
          <p className="text-xs text-slate-500 mt-1">Ranking por unidades pedidas, para saber qué reponer primero.</p>
        </div>
        <div className="flex gap-1 bg-slate-100 rounded-full p-1">
          {RANGES.map((r) => (
            <button key={r.days} onClick={() => setDays(r.days)} className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors ${days === r.days ? "bg-white shadow text-slate-900" : "text-slate-500 hover:text-slate-800"}`} data-testid={`top-range-${r.days}`}>
              {r.label}
            </button>
          ))}
        </div>
      </div>
      {!data && <p className="p-8 text-center text-slate-500 text-sm">Cargando...</p>}
      {data && data.rows.length === 0 && <p className="p-8 text-center text-slate-500 text-sm" data-testid="top-products-empty">Sin pedidos en los últimos {days} días.</p>}
      {data && data.rows.length > 0 && (
        <div className="divide-y divide-slate-100">
          {data.rows.map((r, i) => (
            <div key={r.product_id} className="px-5 py-3 flex items-center gap-4" data-testid={`top-product-${r.product_id}`}>
              <span className="w-6 text-sm font-bold text-slate-400">{i + 1}</span>
              <img src={r.image || "https://images.unsplash.com/photo-1556228578-8c89e6adf883?q=80&w=200"} alt="" className="w-10 h-10 rounded-lg object-cover bg-slate-100 flex-shrink-0" onError={(e) => { e.currentTarget.src = "https://images.unsplash.com/photo-1556228578-8c89e6adf883?q=80&w=200"; }} />
              <div className="flex-1 min-w-0">
                <div className="font-medium text-slate-900 truncate">{r.name}{!r.exists && <span className="ml-2 text-[10px] text-slate-400 uppercase">(eliminado)</span>}</div>
                <div className="flex items-center gap-2 text-xs text-slate-500">
                  {r.sku && <span className="font-mono text-blue-700">{r.sku}</span>}
                  <span>{r.orders_count} pedido{r.orders_count === 1 ? "" : "s"}</span>
                  {r.exists && r.stock !== undefined && r.stock <= 5 && <span className="inline-flex items-center gap-1 text-amber-600 font-semibold"><AlertTriangle className="w-3 h-3" /> stock {r.stock}</span>}
                </div>
                <div className="mt-1.5 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                  <div className="h-full bg-gradient-to-r from-green-500 to-blue-500" style={{ width: `${Math.max(4, (r.quantity / max) * 100)}%` }} />
                </div>
              </div>
              <div className="text-right">
                <div className="font-heading font-bold text-lg text-slate-900" data-testid={`top-qty-${r.product_id}`}>{r.quantity} <span className="text-xs font-normal text-slate-500">u.</span></div>
                <div className="text-xs text-green-700 font-semibold">{formatARS(r.revenue)}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
